import React from 'react';
import { Link } from 'react-router-dom';

import useDocsData from '../docs/useDocsData';
import { formatDuration } from '../video/videoFormat';

/**
 * The video behind a nudge: "Watch how (0:45)", a link to the video's
 * Showcase page, never a player inside the nudge (KPE-062). It draws nothing
 * when no key is given or the compiled manifest has no such video, so a nudge
 * reads as it always did until its video exists.
 */
export function useWatchHowVideo(videoKey) {
	const { data } = useDocsData('videos', { enabled: Boolean(videoKey) });
	if (!videoKey || !Array.isArray(data?.videos)) return null;
	return data.videos.find(entry => entry.key === videoKey) || null;
}

export default function WatchHowLink({ video, className = '' }) {
	const entry = useWatchHowVideo(video);
	if (!entry) return null;
	const length = formatDuration(entry.duration);
	return (
		<Link to={`/docs/showcase/${entry.key}`} className={className} data-testid="watch-how-link">
			{length ? `Watch how (${length})` : 'Watch how'}
		</Link>
	);
}
